import React from "react"

import SupportComponent from "./SupportFaqs"

import supportFactory from "./supportfaqs.factory"

import Styles from "./supportfaqs.module.scss"

export const SupportFaqs = props => {
  const { data, relatedPages, currentPage } = props
  const componentProps = {
    ...props,
    ...supportFactory.transform(data, relatedPages, currentPage, Styles)
  }
  return <SupportComponent {...componentProps} />
}

export default SupportFaqs
